module.exports = __webpack_public_path__ + "static/media/image6.56930362.png";